<template lang="pug">
#timeline
    p.timeline-label {{ $t('mensagens.monitoramento.historico.agricola.selecioneSafra') }}
    .item-historico-container
        .item-historico(
            v-if='historicoAgrupadoPorSafra && historicoAgrupadoPorSafra.length',
            v-for='(hist, index) in historicoAgrupadoPorSafra',
            :key='index',
            :class='{ active: isSelected(index) }',
            @click='selectedValue = index'
        )
            h5.titulo {{ getTitulo(hist).safraDescricao }}

            .info(v-if='isSelected(index)')
                h6.detail {{ $t('mensagens.monitoramento.historico.agricola.producao') }}: <strong class="bold-500">{{ getTitulo(hist).culturas }}</strong>
                .container-details
                    div.details-margin
                        h6.detail <strong class="bold-500">{{ $t('mensagens.monitoramento.historico.agricola.areaPlantada') }}</strong>:
                        .details-row
                            .plant-detail(v-for='area in getAreasPlantadas(hist)' :key='area.nome')
                                span.name {{ area.nome }}
                                span.value {{ area.area }}
                    div
                        h6.detail <strong class="bold-500">{{ $t('mensagens.monitoramento.historico.agricola.produtividade') }}</strong>:
                        .details-row
                            .prod-detail(v-for='prod in getProdutividades(hist)' :key='prod.nome')
                                span.name {{ prod.nome }}
                                span.value {{ prod.produtividade }}

    empty-result(
        v-if='!historico || !historico.length',
        :min-height='150',
        icon-class='mdi-alert-octagon',
        :message='$t("mensagens.monitoramento.historico.agricola.naoHaDadosHistoricosProcessadosParaArea")'
    )
</template>

<script>
import { CULTURAS } from '@/utils/TipoCultura';
import EmptyResult from '@/components/EmptyResult';

import formatters from '@/utils/formatters';

export default {
    name: 'Timeline',

    components: { EmptyResult },

    props: {
        historico: {
            type: Array,
            required: true
        },
        selected: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            selectedValue: null,
            historicoAgrupadoPorSafra: null
        };
    },

    methods: {
        isSelected(indice) {
            return indice === this.selectedValue;
        },
        cultura(codigoCultura) {
            return CULTURAS[codigoCultura].nome;
        },
        isAlgodao(codigoCultura) {
            return codigoCultura === CULTURAS.ALGODAO.codigo;
        },
        getTitulo(historico) {
            const safraDescricao = this.internacionalizarSafra(historico.safra.descricao);
            let culturas;

            if (historico.historicosAgro.length === 1) {
                culturas = this.internacionalizarCulturas(historico.historicosAgro[0].cultura.nome);
            } else {
                culturas = historico.historicosAgro
                    .map(h => this.internacionalizarCulturas(h.cultura.nome))
                    .reverse()
                    .join(` ${this.$t('mensagens.monitoramento.historico.agricola.e')} `);
            }

            return { safraDescricao, culturas };
        },
        getProdutividades(historico) {
            return historico.historicosAgro.map(h => ({
                nome: this.internacionalizarCulturas(h.cultura.nome),
                produtividade: h.produtividadeEstimadaSacasHa
                    ? `${formatters.formatNumber(h.produtividadeEstimadaSacasHa)} sc/ha`
                    : this.$t('mensagens.monitoramento.historico.agricola.semDados')
            })).reverse();
        },
        getAreasPlantadas(historico) {
            return historico.historicosAgro.map(h => ({
                nome: this.internacionalizarCulturas(h.cultura.nome),
                area: h.areaColhidaHa ? `${formatters.formatNumber(h.areaColhidaHa)} ha` : this.$t('mensagens.monitoramento.historico.agricola.semDados')
            })).reverse();
        },
        onChange(selectedValue) {
            const idSafra = this.historico.slice(0, 5)[selectedValue].safra.id;
            this.historicoAgrupadoPorSafra = this.historico.slice(0, 5);
            this.$emit('on-change', idSafra);
        },
        internacionalizarCulturas(cultura) {
            const culturaFormatada = cultura
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .toUpperCase();
            const culturaFormatadaSemEspacos = culturaFormatada.replace(
                /\s+/g,
                '-'
            );
            return this.$t(`mensagens.cultura.${culturaFormatadaSemEspacos}`);
        },
        internacionalizarSafra(descricao) {
            if (descricao.startsWith('Safra')) {
                return descricao.replace('Safra', this.$t('mensagens.monitoramento.historico.agricola.safra'));
            } else if (descricao.startsWith('Safrinha')) {
                return descricao.replace('Safrinha', this.$t('mensagens.monitoramento.historico.agricola.safrinha'));
            } else {
                return descricao;
            }
        }
    },

    watch: {
        selectedValue(selectedValue) {
            this.onChange(selectedValue);
        },
        historico(historico) {
            this.historicoAgrupadoPorSafra = historico.slice(0, 5);

            this.onChange(0);
        }
    },

    created() {
        this.selectedValue = this.selected;
    }
};
</script>

<style lang="scss" scoped>
#timeline {
    background-color: white;
    height: 100%;
    width: 100%;
    padding: 20px;
    overflow: hidden;
    overflow-y: auto;

    .timeline-label {
        font-weight: 500;
    }

    .item-historico-container {
        transition: all 0.3s ease;
    }

    .item-historico {
        margin-top: 15px;
        height: 60px;
        border: 1px solid #E0E0E0;
        padding: 22px 0 10px 20px;
        cursor: pointer;
        position: relative;
        background-color: var(--white);
        border-radius: 5px;
        font-size: 12px;
        transition: all 0.3s ease;

        .titulo {
            color: #3B3B3B;
            font-weight: 500;
            padding: 0;
        }

        .info {
            .detail {
                color: var(--primary-font-color);
            }
        }
    }

    .item-historico.active {
        height: auto;
        background-color: #F4FAE8 !important;
        border: 1px solid #359138;
        transition: all 0.3s ease;

        .titulo {
            margin-bottom: 10px;
        }

        .info {
            .detail {
                margin-bottom: 10px;
                font-size: 12px;
            }

            .container-details {
                display: flex;
                .details-row {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 10px;
                    min-width: 130px;

                    .plant-detail, .prod-detail {
                        display: flex;
                        flex-direction: column;
                        text-align: left;
                        width: 85px;
                        .name {
                            color: black !important;
                            font-weight: 400;
                            margin-bottom: 3px;
                        }
                        .value {
                            color: black !important;
                            font-weight: 500;
                        }
                    }
                }
                .details-margin {
                    border-right: 2px solid #E0E0E0;
                    margin-right: 15px;
                }
            }
        }
    }

    .bold-500 {
        font-weight: 500 !important;
    }

    .item-historico-container-enter-active, .item-historico-container-leave-active {
        transition: all 0.3s ease;
    }
    .item-historico-container-enter, .item-historico-container-leave-to {
        opacity: 0;
        transform: translateY(30px);
    }
}
</style>
